<template>
  <div class="dashboard-container">
    <!-- 🔥 GRÁFICO GRANDE -->
    <div class="chart-wrapper">
      <canvas ref="chart"></canvas>
    </div>

    <!-- 🔥 RESUMO -->
    <div class="summary-wrapper">
      <div class="monitoring-title">Resumo dos Chamados</div>

      <table class="monitoring-table">
        <tr class="row-click" @click="openCallsModal('all')">
          <td><span class="dot black"></span> Todos os Chamados</td>
          <td class="value">{{ resumo.todos }}</td>
        </tr>

        <tr class="row-click" @click="openCallsModal('within')">
          <td><span class="dot green"></span> Dentro do Prazo</td>
          <td class="value">{{ resumo.dentro_prazo }}</td>
        </tr>

        <tr class="row-click" @click="openCallsModal('due_soon')">
          <td><span class="dot yellow"></span> Prazo a Vencer</td>
          <td class="value">{{ resumo.prazo_vencer }}</td>
        </tr>

        <tr class="row-click" @click="openCallsModal('overdue')">
          <td><span class="dot red"></span> Fora do Prazo</td>
          <td class="value">{{ resumo.fora_prazo }}</td>
        </tr>

        <tr class="row-click" @click="openCallsModal('no_owner')">
          <td><span class="dot blue"></span> Sem Posse</td>
          <td class="value">{{ resumo.sem_posse }}</td>
        </tr>
      </table>

      <!-- ✅ BOTÃO NO CANTO -->
      <button class="btn-filter-corner" @click="openFilterModal">Filtro</button>

      <!-- ✅ indicador opcional -->
      <div v-if="hasActiveFilters" class="filter-active-badge">
        filtro ativo
      </div>
    </div>

    <!-- ✅ MODAL DE FILTRO -->
    <div
      v-if="filterModalOpen"
      class="filter-modal-backdrop"
      @click.self="closeFilterModal"
    >
      <div class="filter-modal-card">
        <div class="modal-header">
          <h5 class="modal-title">Filtrar Dashboard</h5>
          <button class="modal-close" @click="closeFilterModal">×</button>
        </div>

        <div class="modal-body">
          <div class="row">
            <div class="col-md-6">
              <label>Data início</label>
              <input
                type="date"
                class="form-control"
                v-model="filters.date_from"
              />
            </div>

            <div class="col-md-6">
              <label>Data fim</label>
              <input
                type="date"
                class="form-control"
                v-model="filters.date_to"
              />
            </div>
          </div>

          <div class="row mt-2">
            <div class="col-md-12">
              <label>Usuário</label>
              <v-select
                v-model="filters.user_id"
                :options="users"
                :reduce="(u) => u.id"
                label="name"
                placeholder="Selecione..."
              />
            </div>
          </div>

          <div class="row mt-2">
            <div class="col-md-12">
              <label>Cliente</label>
              <v-select
                v-model="filters.client_id"
                :options="clients"
                :reduce="(c) => c.id"
                label="company_name"
                placeholder="Selecione..."
              />
            </div>
          </div>

          <div class="row mt-2">
            <div class="col-md-12">
              <label>Departamento</label>
              <v-select
                v-model="filters.department_id"
                :options="departments"
                :reduce="(d) => d.id"
                label="name"
                placeholder="Selecione..."
              />
            </div>
          </div>

          <!-- ✅ NOVO: STATUS -->
          <div class="row mt-2">
            <div class="col-md-12">
              <label>Status</label>
              <select v-model="filters.status" class="form-control">
                <option value="all">Todos</option>
                <option value="open">Abertos</option>
                <option value="done">Finalizados</option>
              </select>
            </div>
          </div>
        </div>

        <div class="filter-modal-footer">
          <button
            class="btn btn-secondary"
            :disabled="loadingResumo"
            @click="clearFilters"
          >
            Limpar
          </button>

          <button
            class="btn btn-primary"
            :disabled="loadingResumo"
            @click="applyFilters"
          >
            Aplicar
          </button>
        </div>
      </div>
    </div>

    <!-- ✅ MODAL DE CHAMADOS -->
    <div v-if="modalOpen" class="calls-modal-backdrop" @click.self="closeModal">
      <div class="calls-modal-card">
        <div class="modal-header">
          <h5 class="modal-title">{{ modalTitle }}</h5>
          <button class="modal-close" @click="closeModal">×</button>
        </div>

        <div class="modal-body calls-modal-body">
          <div v-if="modalLoading">Carregando...</div>

          <div v-else>
            <div v-if="modalCalls.length === 0" class="text-muted">
              Nenhum chamado encontrado.
            </div>

            <div v-else class="table-responsive">
              <table class="table table-sm table-bordered">
                <thead>
                  <tr>
                    <!-- NOVA COLUNA -->

                    <th>ID</th>
                    <th>Título</th>
                    <th>Cliente</th>
                    <th>Departamento</th>
                    <th>Responsável</th>
                    <th>Prazo</th>
                    <th>Status</th>
                    <th class="col-view">Visualizar</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="c in modalCalls" :key="c.id">
                    <td>{{ c.id }}</td>
                    <td>{{ c.title || "—" }}</td>
                    <td>{{ clientName(c.client_id) }}</td>
                    <td>{{ departmentName(c.department_id) }}</td>
                    <td>{{ responsibleName(c.dev_acting) }}</td>
                    <td>{{ c.deadline_f || c.deadline || "—" }}</td>
                    <td>
                      {{ c.sla && c.sla.text ? c.sla.text : c.status || "—" }}
                    </td>

                    <td class="text-center col-view">
                      <button
                        type="button"
                        class="btn-view"
                        title="Visualizar"
                        @click.stop="viewCall(c)"
                      >
                        <!-- se font-awesome não existir, troca por i-Eye -->
                        <i class="fa fa-eye"></i>
                        <!-- ou: <i class="i-Eye"></i> -->
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- paginator fixo -->
        <div v-if="modalTotal > modalPerPage" class="modal-paginator">
          <small class="text-muted">
            Página {{ modalPage }} de {{ modalLastPage }} — Total:
            {{ modalTotal }}
          </small>

          <div class="modal-paginator-actions">
            <button
              class="btn btn-sm btn-outline-secondary"
              :disabled="modalPage <= 1 || modalLoading"
              @click="goToPage(modalPage - 1)"
            >
              ‹ Anterior
            </button>

            <button
              class="btn btn-sm btn-outline-secondary"
              :disabled="modalPage >= modalLastPage || modalLoading"
              @click="goToPage(modalPage + 1)"
            >
              Próxima ›
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js";
import axios from "axios";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  components: { vSelect },

  data() {
    return {
      resumo: {
        todos: 0,
        dentro_prazo: 0,
        prazo_vencer: 0,
        fora_prazo: 0,
        sem_posse: 0,
      },

      chart: null,

      // ✅ filtros dashboard
      filterModalOpen: false,
      loadingResumo: false,
      filters: {
        date_from: "",
        date_to: "",
        user_id: null,
        client_id: null,
        department_id: null,
        status: "open",
      },

      // modal chamados
      modalOpen: false,
      modalLoading: false,
      modalFilter: "all",
      modalCalls: [],

      // paginação modal
      modalPage: 1,
      modalPerPage: 20,
      modalTotal: 0,
      modalLastPage: 1,

      // maps para nomes
      users: [],
      usersById: {},

      clients: [],
      clientsById: {},

      departments: [],
      departmentsById: {},
    };
  },

  computed: {
    modalTitle() {
      const map = {
        all: "Todos os Chamados",
        within: "Chamados Dentro do Prazo",
        due_soon: "Chamados com Prazo a Vencer",
        overdue: "Chamados Fora do Prazo",
        no_owner: "Chamados Sem Posse",
      };
      return map[this.modalFilter] || "Chamados";
    },

    hasActiveFilters() {
      const f = this.filters;
      return !!(
        f.date_from ||
        f.date_to ||
        f.user_id ||
        f.client_id ||
        f.department_id ||
        (f.status && f.status !== "open")
      );
    },
  },

  mounted() {
    this.loadResumo();
    this.getUsers();
    this.getClients();
    this.getDepartments();
  },

  methods: {
    // ✅ remove params vazios + NÃO manda status=all pro backend
    buildFilterParams(extra = {}) {
      const params = { ...this.filters, ...extra };

      Object.keys(params).forEach((k) => {
        if (params[k] === "" || params[k] === null || params[k] === undefined) {
          delete params[k];
        }
      });

      return params;
    },
    viewCall(call) {
      const url = `${window.location.origin}/calls/ticket/${call.id}`;
      window.open(url, "_blank");
    },

    openFilterModal() {
      this.filterModalOpen = true;
    },

    closeFilterModal() {
      this.filterModalOpen = false;
    },

    async applyFilters() {
      this.filterModalOpen = false;

      await this.loadResumo();

      if (this.modalOpen) {
        this.modalPage = 1;
        this.fetchModalCalls();
      }
    },

    async clearFilters() {
      this.filters = {
        date_from: "",
        date_to: "",
        user_id: null,
        client_id: null,
        department_id: null,
        status: "open",
      };
      await this.applyFilters();
    },

    async loadResumo() {
      this.loadingResumo = true;
      try {
        const api = this.$store.state.api + "monitorings/resumo-chamados";
        const params = this.buildFilterParams();
        const res = await axios.get(api, { params });

        this.resumo = res.data;
        this.$nextTick(() => this.renderChart());
      } catch (e) {
        console.error(e);
      } finally {
        this.loadingResumo = false;
      }
    },

    async openCallsModal(filter) {
      this.modalFilter = filter;
      this.modalOpen = true;
      this.modalPage = 1;
      this.modalCalls = [];

      if (!Object.keys(this.usersById).length) await this.getUsers();
      if (!Object.keys(this.clientsById).length) await this.getClients();
      if (!Object.keys(this.departmentsById).length)
        await this.getDepartments();

      this.fetchModalCalls();
    },

    closeModal() {
      this.modalOpen = false;
    },

    goToPage(page) {
      if (page < 1) return;
      if (page > this.modalLastPage) return;
      if (page === this.modalPage) return;

      this.modalPage = page;
      this.fetchModalCalls();
    },

    async fetchModalCalls() {
      this.modalLoading = true;
      try {
        const api = this.$store.state.api + "monitorings/chamados";

        const params = this.buildFilterParams({
          filter: this.modalFilter,
          per_page: this.modalPerPage,
          page: this.modalPage,
        });

        // ✅ REGRA: "Sem Posse" NÃO filtra por user
        if (this.modalFilter === "no_owner") {
          delete params.user_id;
        }

        const res = await axios.get(api, { params });

        this.modalCalls = (res.data.data || []).filter(Boolean);
        this.modalTotal = res.data.total || 0;
        this.modalLastPage = res.data.last_page || 1;

        this.modalPage = res.data.current_page || this.modalPage;
        this.modalPerPage = res.data.per_page || this.modalPerPage;
      } catch (e) {
        console.error(e);
        this.modalCalls = [];
        this.modalTotal = 0;
        this.modalLastPage = 1;
      } finally {
        this.modalLoading = false;
      }
    },

    async getUsers() {
      const api = this.$store.state.api + "users?paginated=false";
      const res = await axios.get(api);
      this.users = res.data.data || [];
      this.usersById = this.users.reduce((acc, u) => {
        acc[u.id] = u.name || `#${u.id}`;
        return acc;
      }, {});
    },

    async getClients() {
      const api = this.$store.state.api + "clients?paginated=false";
      const res = await axios.get(api);
      this.clients = res.data.data || [];
      this.clientsById = this.clients.reduce((acc, c) => {
        acc[c.id] = c.company_name || c.name || `#${c.id}`;
        return acc;
      }, {});
    },

    async getDepartments() {
      const api = this.$store.state.api + "departments?paginated=false";
      const res = await axios.get(api);
      this.departments = res.data.data || [];
      this.departmentsById = this.departments.reduce((acc, d) => {
        acc[d.id] = d.name || d.description || `#${d.id}`;
        return acc;
      }, {});
    },

    responsibleName(id) {
      if (!id) return "—";
      return this.usersById[id] || `#${id}`;
    },

    clientName(id) {
      if (!id) return "—";
      return this.clientsById[id] || `#${id}`;
    },

    departmentName(id) {
      if (!id) return "—";
      return this.departmentsById[id] || `#${id}`;
    },

    handleBarClick(index) {
      const map = {
        0: "all",
        1: "within",
        2: "due_soon",
        3: "overdue",
        4: "no_owner",
      };
      const filter = map[index];
      if (filter) this.openCallsModal(filter);
    },

    renderChart() {
      if (!this.$refs.chart) return;
      if (this.chart) this.chart.destroy();

      const ctx = this.$refs.chart.getContext("2d");

      this.chart = new Chart(ctx, {
        type: "bar",
        data: {
          labels: [
            "Todos",
            "Dentro do Prazo",
            "Prazo a Vencer",
            "Fora do Prazo",
            "Sem Posse",
          ],
          datasets: [
            {
              data: [
                this.resumo.todos,
                this.resumo.dentro_prazo,
                this.resumo.prazo_vencer,
                this.resumo.fora_prazo,
                this.resumo.sem_posse,
              ],
              backgroundColor: [
                "#000000",
                "#24a148",
                "#f1c21b",
                "#da1e28",
                "#0f62fe",
              ],
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: { display: false },
          onClick: (event, elements) => {
            if (!elements.length) return;
            const index = elements[0]._index;
            this.handleBarClick(index);
          },
          scales: {
            yAxes: [{ ticks: { beginAtZero: true, precision: 0 } }],
          },
        },
      });
    },
  },
};
</script>

<style>
.monitoring-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
}

.monitoring-table {
  width: 100%;
  border-collapse: collapse;
}

.monitoring-table td {
  font-size: 14px;
  padding: 6px 0;
  border-bottom: 1px solid #e7e7e7;
}

.monitoring-table tr:last-child td {
  border-bottom: none;
}
.value {
  text-align: right;
  font-weight: 600;
}

.dot {
  width: 18px;
  height: 10px;
  display: inline-block;
  border-radius: 3px;
  margin-right: 8px;
}

.black {
  background: #000;
}
.green {
  background: #24a148;
}
.yellow {
  background: #f1c21b;
}
.red {
  background: #da1e28;
}
.blue {
  background: #0f61f9;
}

.dashboard-container {
  display: flex;
  gap: 24px;
  width: 100%;
  align-items: stretch;
}

.chart-wrapper {
  flex: 2;
  background: #fff;
  border: 1px solid #d6d6d6;
  border-radius: 8px;
  padding: 24px;
  height: 420px;
}

.summary-wrapper {
  flex: 1;
  background: #fff;
  border: 1px solid #d6d6d6;
  border-radius: 8px;
  padding: 24px;
  position: relative;
}

.row-click td {
  cursor: pointer;
}
.row-click:hover {
  background: #f6f6f6;
}

.btn-filter-corner {
  position: absolute;
  right: 16px;
  bottom: 16px;
  padding: 4px 12px;
  border: 1px solid #111;
  background: transparent;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
}

.filter-active-badge {
  position: absolute;
  left: 16px;
  bottom: 18px;
  font-size: 12px;
  color: #0f62fe;
}

/* modal chamados */
.calls-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  z-index: 999999;
}

.calls-modal-card {
  width: min(1100px, 98vw);
  max-height: 85vh;
  background: #fff;
  border-radius: 10px;
  padding: 16px;
  display: flex;
  flex-direction: column;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
  margin-bottom: 12px;
}

.modal-close {
  border: none;
  background: transparent;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
}

.calls-modal-body {
  flex: 1;
  overflow-y: auto;
  max-height: 65vh;
}

.modal-paginator {
  border-top: 1px solid #eee;
  padding-top: 10px;
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.modal-paginator-actions {
  display: flex;
  gap: 8px;
}

/* modal filtro */
.filter-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  z-index: 1000000;
}

.filter-modal-card {
  width: min(520px, 96vw);
  background: #fff;
  border-radius: 10px;
  padding: 16px;
}

.filter-modal-footer {
  border-top: 1px solid #eee;
  padding-top: 12px;
  margin-top: 12px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.col-view {
  width: 42px;
}

.btn-view {
  width: 26px;
  height: 26px;
  padding: 0;
  border: 2px solid #28a745;
  border-radius: 6px;
  background: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.btn-view i {
  font-size: 12px;
}

.btn-view:hover {
  background: #28a745;
  color: #fff;
}
</style>
